import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubjectLetterService {
  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Subject_Letter?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Subject_Letter/GetActiveList?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Subject_Letter/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddSubject_Letter(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Subject_Letter/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditSubject_Letter(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Subject_Letter/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteSubject_Letter(id:number,Token:String):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Subject_Letter/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  }
